import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import UserMenu from "../components/UserMenu";
import API_BASE_URL from "../utilities/ApiConfig";

const DashboardRegDetails = () => {
  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedSRO, setSelectedSRO] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFromDate(today);
    setToDate(today);
  }, []);

  useEffect(() => {
    fetchDistricts();
  }, []);

  useEffect(() => {
    if (selectedDistrict) {
      fetchSros(selectedDistrict);
    } else {
      setSros([]);
    }
  }, [selectedDistrict]);

  useEffect(() => {
    fetchDashboardData();
  }, [selectedDistrict, selectedSRO, fromDate, toDate]);

  const fetchDistricts = async () => {
    const res = await axios.get(`${API_BASE_URL}/Master/get_District_Mas`);
    setDistricts(res.data.data);
  };

  const fetchSros = async (dcode) => {
    const res = await axios.get(
      `${API_BASE_URL}/Master/get_sro_master_data?dcode=${dcode}`
    );
    setSros(res.data.data);
  };

  const fetchDashboardData = async () => {
    const dcodeParam = selectedDistrict || "";
    const srocodeParam = selectedSRO || "";
    const from = fromDate;
    const to = toDate;

    if (!from) {
      return;
    } else {
      const url = `${API_BASE_URL}/DashBoard/virtual-registry-dashboard?dcode=${dcodeParam}&srocode=${srocodeParam}&fromDate=${from}&toDate=${to}`;
      try {
        const res = await axios.get(url);
        setDashboardData(res.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="flex flex-col flex-1 overflow-y-auto bg-gray-50">
        <div className="shadow-sm bg-white">
          <Header />
        </div>

        <div className="flex-1 w-full px-4 py-6">
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-gray-700">
                Analyze Sub Registrar Office Activity
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="border border-hidden p-2 text-[#6F6F6F] rounded w-full bg-[#F1F1F1]"
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="border border-hidden p-2 text-[#6F6F6F] rounded w-full bg-[#F1F1F1]"
              />
              <select
                className="border border-hidden p-2 text-[#6F6F6F] rounded w-full bg-[#F1F1F1]"
                value={selectedDistrict}
                onChange={(e) => {
                  setSelectedDistrict(e.target.value);
                  setSelectedSRO(""); // reset SRO
                }}
              >
                <option value="">Select District</option>
                {districts.map((d) => (
                  <option key={d.dcode} value={d.dcode}>
                    {d.districtName}
                  </option>
                ))}
              </select>
              <select
                className="border border-hidden text-[#6F6F6F] p-2 rounded w-full bg-[#F1F1F1]"
                value={selectedSRO}
                onChange={(e) => setSelectedSRO(e.target.value)}
                disabled={!selectedDistrict}
              >
                <option value="">Select SRO</option>
                {sros.map((s) => (
                  <option key={s.srocode} value={s.srocode}>
                    {s.sroname}
                  </option>
                ))}
              </select>
              <div className="hidden lg:block" />{" "}
            </div>

            {dashboardData && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8 text-center">
                <div className="bg-blue-100 p-4 rounded shadow">
                  <h3 className="text-3xl font-bold text-[#0E57AF]">
                    {dashboardData.registration}
                  </h3>
                  <p className="text-[#6F6F6F]">Total Registration</p>
                </div>

                <div className="bg-green-100 p-4 rounded shadow">
                  <h3 className="text-3xl font-bold text-[#0E57AF]">
                    {dashboardData.regularized}
                  </h3>
                  <p className="text-[#6F6F6F]">Total Regularization</p>
                </div>

                <div className="bg-purple-100 p-4 rounded shadow">
                  <h3 className="text-3xl font-bold text-[#0E57AF]">
                    {dashboardData.filteredPDECount}
                  </h3>
                  <p className="text-[#6F6F6F]">Total PDE</p>
                </div>

                <div className="bg-yellow-100 p-4 rounded shadow">
                  <div className="space-y-2">
                    <div className="flex gap-2">
                      <div>
                        <h3 className="text-3xl font-bold text-[#0E57AF]">
                          {dashboardData.totalScanCount}
                        </h3>
                        <p className="text-[#6F6F6F]">Total Scan</p>
                      </div>
                      <div>
                        <h3 className="text-3xl font-bold text-[#af0e0e]">
                          {dashboardData.totalNotScanCount}
                        </h3>
                        <p className="text-[#6F6F6F]">Total NotScanned</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="bg-blue-100 text-center p-0">
          <Footer />
        </div>
      </div>

      <div className="hidden md:block w-64 h-full border-l bg-white">
        <UserMenu />
      </div>
    </div>
  );
};

export default DashboardRegDetails;
